



































































































































































































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import FilterDeliverySacPublic from '@/components/filters/FilterDeliverySacPublic.vue'
import CargaCollection from '@/model/collection/CargaCollection'
import Carga from '@/model/resource/Carga'
import SacResponse from '@/model/response/SacResponse'
import FilterToggle from '@/components/FilterToggle.vue'
import itTrackingSlider from '@/components/itrack/ItTrackingSlider.vue'
import * as Helper from '@/helpers'
import {MapConfig} from '@/config/map.config'
import moment from 'moment'
import FilterSacCnhIveco from '@/components/filters/FilterSacCnhIveco.vue'
import SacCnhIvecoRequest from '@/model/request/SacCnhIvecoRequest'
import DeliverySacCnhIvecoResponse from '@/model/resource/DeliverySacCnhIvecoResponse'

enum State {
    INIT = 1,
    SELECTED = 2,
    LISTED = 3,
}

const metaInfo = () => ({
    title: $.t('view.reports.deliverySacPublic.title'),
})

@Component({
    metaInfo,
    components: {FilterSacCnhIveco, FilterDeliverySacPublic, FilterToggle, itTrackingSlider},
})
export default class ReportsDeliverySacPublicResultView extends Mixins(MixinFilter) {
    @Prop({type: String}) type?: string
    @Prop({type: String, default: null}) token?: string | null

    AppConfig = AppConfig
    State = State
    Helper = Helper
    MapConfig = MapConfig

    state = State.INIT

    // Selected item
    model: Carga | null = null
    emptyListTitle: String | null = null

    filter = new SacCnhIvecoRequest()
    filterSac = new SacCnhIvecoRequest()

    get isDirect() {
        return this.$route.path.includes('direct')
    }

    collectionSac = new PageCollection(SacResponse, this.filterSac, null, null)
    collection = new CargaCollection(this.filter, null, 10)

    showFilter = true
    populateOnMount = false

    queriesToHide: string[] = ['login', 'senha']

    async populate() {
        try {
            await this.query()
        } catch (e) {
            if (e.status === 400) {
                this.emptyListTitle = e.body.message
            }
        }
    }

    applyResource() {
        if (this.isDirect) {
            this.collection.endpoint = '/user/cnhIveco/sac/direct'
        } else {
            this.collection.endpoint = '/user/cnhIveco/sac'
        }
    }

    @Watch('collection.items', {deep: true})
    listEvent(items: Carga[]) {
        if (!this.filter.isCleared && items.length === 1) {
            this.select(items[0])
        }

        if (items.length === 0) {
            this.emptyListTitle = $.t('view.reports.deliverySacPublic.fragmentDinamicEmptyListNoElements')
        }
    }

    @Watch('state')
    async stateEvent(state: State) {
        if (state === State.LISTED) {
            this.model = null
            this.collectionSac.items = []
        } else if (state === State.SELECTED) {
            await Helper.sleep(1000)

            if (this.model) {
                await this.collectionSac.search()
            }
        } else if (state === State.INIT) {
            this.model = null

            this.filter.clean()
            this.filterSac.clean()

            this.collection.items = []
            this.collectionSac.items = []

            this.showFilter = false
            await this.$nextTick()
            this.showFilter = true
        }
    }

    get eyeIcon() {
        return `<img src="./img/itrack/view-circle-contrast.svg" alt="view-circle">`
    }

    get lastSac() {
        const items = this.collectionSac.items
        return items[items.length - 1]
    }

    list() {
        this.state = State.LISTED
        if (this.filter.dataCriacao != null)  {
            const comp = moment().subtract(3, 'months')
            const  date = moment(this.filter.dataCriacao)
            if (comp.isAfter(date)) {

                this.emptyListTitle = $.t('view.reports.deliverySacPublic.fragmentDinamicEmptyList')
                    + ' ' +  comp.format('DD/MM/YYYY')
            }
        }
    }

    select(model: Carga) {
        this.state = State.SELECTED
        this.model = model
        this.filterSac.danfe = model.danfe
        this.filterSac.nroFiscal = model.nroNotaFiscal
        this.filterSac.idEmbarcador = model.embarcador.responsavel.$id
        this.filterSac.idCarga = model.idCargaPk
    }

    init() {
        this.state = State.INIT
    }

    async backToList() {
      this.filterSac.idCarga = null
      this.filter.idCarga = null
      await this.filtrateSac()
    }

    async filtrateSac() {
        if (this.filter.isCleared) {
            this.init()
        } else {
            this.list()
        }
        await Helper.sleep(1000)
        await this.filtrate()
    }

    async clean() {
        this.filter = new SacCnhIvecoRequest()
        this.filterSac = new SacCnhIvecoRequest()
        await this.filtrateSac()
    }

  get cargaSessionPublicCnhIveco2() {
    return this.model && this.model.posicaoMotorista ?
      AppConfig.fieldsToRender.reportsDeliverySac.CargaSessionPublicCnhIveco2ShowSacPrivado
      : AppConfig.fieldsToRender.reportsDeliverySac.CargaSessionPublicCnhIveco2
  }

    async mounted() {
        this.applyResource()
        if (this.filter.isCleared && !this.isDirect) {
          this.$router.push('/sac/cnhIveco')
        }

        this.collectionSac.endpoint = '/user/carga/tentativa/guest'

        if (!this.$route.query.token && !this.type && !this.isDirect) {
          this.$modal.open('prompt')
        } else {
          try {
            await this.filtrateSac()
          } catch {
            this.$router.replace('/sac/cnhIveco')
          }
        }

        if (this.filter.cpfCnpj) {
          this.filter.login = `${this.filter.cpfCnpj}`
        }
    }

    async downloadData(isCsv: boolean) {
      if (this.state === State.SELECTED) {
        this.filter.idCarga = this.filterSac.idCarga
      } else {
        this.filter.idCarga = null
      }

      const url = this.isDirect ? '/user/cnhIveco/sac/direct/report' : '/user/cnhIveco/sac/report'

      if (!isCsv) {
        await $.await.run(() => Helper.downloadXlsx(
            $.t('classes.DeliverySacCnhIvecoResponse.title'),
            url,
            this.filter,
            DeliverySacCnhIvecoResponse,
            'DeliverySacCnhIvecoResponse',
        ), 'downloadXlsx')
      } else {
        const csv = new PageCollection(DeliverySacCnhIvecoResponse, this.filter, null, null)
        csv.endpoint = url
        const fetch = async () => await csv.search()
        await $.await.run(fetch, 'downloadCsv')
        csv.downloadCsv($.t('classes.DeliverySacCnhIvecoResponse.title'))
      }
    }

    getCircleSlaColor(item: Carga) {
      return item.slaCircleClass
    }

    onFilter() {
      this.filtrate()
      this.state = State.LISTED
    }

    async submitPrompt() {
      this.$modal.close('prompt')

      try {
        await this.filtrateSac()
      } catch {
        Helper.backHistory()
      }
    }
}
